export default {
  '2004': {
    exit: 'cmi.exit',
    entry: 'cmi.entry',
    location: 'cmi.location',
    scoreMin: 'cmi.score.min',
    scoreMax: 'cmi.score.max',
    scoreScaled: 'cmi.score.scaled',
    scoreRaw: 'cmi.score.raw',
    success: 'cmi.success_status',
    completion: 'cmi.completion_status',
    suspend_data: 'cmi.suspend_data',
    result: {
      0: "incorrect",
      1: "correct"
    }
  },
  '1.2': {
    exit: 'cmi.core.exit',
    entry: 'cmi.core.entry',
    location: 'cmi.core.lesson_location',
    scoreMin: 'cmi.core.score.min',
    scoreMax: 'cmi.core.score.max',
    scoreRaw: 'cmi.core.score.raw',
    completion: 'cmi.core.lesson_status',
    suspend_data: 'cmi.suspend_data',
    result: {
      0: "wrong",
      1: "correct"
    }
  },
};
